export default __webpack_public_path__ + "static/banner-background-c68530a2ae516a4f74cb47dd7d0ac60f.png";